import React from "react"
import { Flex } from "rebass"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import Toggle from "material-ui/Toggle"
import { Card, CardHeader, CardText } from "material-ui/Card"
import { SketchColorPicker } from "../../../../../components"
import { DivContent } from "../../styled"
//DivTitle,
import { typeContainer } from "./utils"
import { Counter } from "../counter"

const itemTypeContainer = []
for (let i = 0; i < typeContainer.length; i++) {
  const item = typeContainer[i]
  itemTypeContainer.push(
    <MenuItem value={item.id} key={i} primaryText={item.name} />
  )
}

const General = (props) => {
  const {
    state,
    onSetValue,
    onUpdateContainer,
    onToggle,
    onUpdateContainerType,
    styles,
  } = props
  const { container } = state
  const containerHeight = container.height.split("px").join("") * 1
  const pdtQuery = container.paddingTopQuery
  const paddingTopQuery0 = pdtQuery[0].split("px").join("") * 1
  const paddingTopQuery1 = pdtQuery[1].split("px").join("") * 1
  return (
    <div style={styles.paperCard}>
      <Card
        expanded={state.expandGeneral}
        onExpandChange={(expand) => onSetValue("expandGeneral", expand)}
      >
        <CardHeader
          title="General"
          subtitle="Container"
          actAsExpander={true}
          showExpandableButton={true}
          style={styles.headerCard}
        />
        <CardText expandable={true}>
          <DivContent>
            <SketchColorPicker
              title={"Background Color"}
              onUpdateColor={(color) =>
                onUpdateContainer("backgroundColor", color)
              }
              color={state.container.backgroundColor}
            />
          </DivContent>
          <SelectField
            floatingLabelText="Type"
            value={state.container.type}
            onChange={onUpdateContainerType}
            maxHeight={200}
          >
            {itemTypeContainer}
          </SelectField>
          <Flex
            w={[1]}
            pt={[2]}
            direction={"row"}
            align={"center"}
            wrap={"wrap"}
            justify={"space-between"}
          >
            <Toggle
              label="Auto Play"
              style={{ marginBottom: 10, marginTop: 10, width: 180 }}
              toggled={state.container.auto}
              onToggle={(e, v) => onToggle(e, v)}
            />
            <Counter
              isDisabled={false}
              title="Height"
              onSetValue={(value) => onUpdateContainer("height", value)}
              value={containerHeight}
              interval={1}
              subtitle=""
              minValue={200}
            />
          </Flex>
          <Flex
            w={[1]}
            pt={[2]}
            direction={"row"}
            align={"center"}
            wrap={"wrap"}
            justify={"space-between"}
          >
            <Counter
              isDisabled={false}
              title="Padding Top Mobile"
              onSetValue={(value) =>
                onUpdateContainer("paddingTopQuery0", value)
              }
              value={paddingTopQuery0}
              interval={1}
              subtitle="px"
              minValue={0}
            />
            <Counter
              isDisabled={false}
              title="Padding Top Desktop"
              onSetValue={(value) =>
                onUpdateContainer("paddingTopQuery1", value)
              }
              value={paddingTopQuery1}
              interval={1}
              subtitle="px"
              minValue={0}
            />
          </Flex>
        </CardText>
      </Card>
    </div>
  )
}

export default General



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/General.js